import { Card, CardBody, CardHeader } from '@/components/ui/Card'

/** The courier booking on an order, as both the staff and the shopper order pages show it. */
export interface Shipment {
  awb_code: string | null
  courier_name: string | null
  shipment_status: string | null
  shipment_updated_at: string | null
}

export function ShipmentCard({ shipment }: { shipment: Shipment }) {
  if (!shipment.awb_code && !shipment.shipment_status) return null
  return (
    <Card>
      <CardHeader title="Shipment" />
      <CardBody className="space-y-1 text-sm text-slate-700 dark:text-slate-300">
        {shipment.courier_name && <p className="font-medium">{shipment.courier_name}</p>}
        {shipment.awb_code && (
          <p>
            AWB{' '}
            <a
              href={`https://shiprocket.co/tracking/${encodeURIComponent(shipment.awb_code)}`}
              target="_blank"
              rel="noreferrer"
              className="font-mono text-brand-600 underline dark:text-brand-400"
            >
              {shipment.awb_code}
            </a>
          </p>
        )}
        {shipment.shipment_status && (
          <p className="text-slate-500 dark:text-slate-400">
            {shipment.shipment_status}
            {shipment.shipment_updated_at &&
              ` · ${new Date(shipment.shipment_updated_at).toLocaleString()}`}
          </p>
        )}
      </CardBody>
    </Card>
  )
}
